import { NodeDefinition } from '../../../types'
import { StartNodeIcon } from '../start.icon'
import { StartEditorNode } from '../start.editorNode'
import { StartContractUploadedConfigForm } from './startContractUploaded.configForm'
import { StartNodeTrigger } from '..'
import {
  handlesConnected,
  requiresContractExtraction,
  requiresCreateSchedule,
  triggerTypeRequired
} from '../start.validators'
import { semanticTypes } from 'Automations/nodeDefinitions/semanticTypes'
import { ContractUploadedExecutionSummary } from './ContractUploaded.executionSummary'

export type Config = {
  name: string
  trigger: StartNodeTrigger
}

type Outputs = 'assetId' | 'requestorId'

export const startContractUploadedNodeDefinition: NodeDefinition<
  Config,
  string,
  Outputs
> = {
  name: 'Start',
  startNodeTriggerType: 'CONTRACT_UPLOADED',
  description: 'Contract uploaded',
  icon: StartNodeIcon,
  editorNode: StartEditorNode,
  configForm: StartContractUploadedConfigForm,
  defaultConfig: {
    name: '',
    trigger: 'CONTRACT_UPLOADED'
  },
  validation: {
    node: {
      ERROR: [requiresContractExtraction, requiresCreateSchedule],
      WARN: []
    },
    config: {
      name: { ERROR: [], WARN: [] },
      trigger: { ERROR: [triggerTypeRequired], WARN: [] }
    },
    handles: { ERROR: [handlesConnected], WARN: [] }
  },
  isPersistent: true,
  outputMapping: () => ({
    assetId: {
      id: 'workflow.input.assetId',
      semanticType: semanticTypes.sequence.asset.id
    },
    requestorId: {
      id: 'workflow.input.requestorId',
      semanticType: semanticTypes.sequence.requestorId
    },
    assetFileName: {
      id: 'workflow.input.fileName',
      semanticType: semanticTypes.sequence.asset.fileName
    }
  }),
  taskTransformer: () => [],
  startNodeInputParameters: ['sequenceAccountId', 'assetId'],
  executionSummary: ContractUploadedExecutionSummary
}
